var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { EntityImage } from '../entities/entity-image';
import { CrossRoundedIconGlyph } from '@shapeable/icons';
import { IconButton } from './icon-button';
import { useDialogs } from '../hooks/use-dialogs';
import { useLang } from '../hooks/use-lang';
import { EntityDeleteDialog } from '../entities/entity-delete-dialog';
var cls = classNames('conversations-preview-attachments');
export var ConversationsPreviewAttachmentsDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    padding: 0 ", " ", ";\n    width: 80px;\n    height: 80px;\n    border-radius: ", ";\n  "], ["\n    position: relative;\n    padding: 0 ", " ", ";\n    width: 80px;\n    height: 80px;\n    border-radius: ", ";\n  "])), theme.UNIT(3), theme.UNIT(3), theme.UNIT(5)),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 140px;\n    height: auto;\n  "], ["\n    width: 140px;\n    height: auto;\n  "])))
});
var ImageStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    img {\n      border-radius: ", ";\n      object-fit: fit;\n    }\n  "], ["\n    img {\n      border-radius: ", ";\n      object-fit: fit;\n    }\n  "])), theme.UNIT(5))
});
var RemoveAttachmentButtonStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    border-radius: ", ";\n    background: ", ";\n    z-index: 1;\n    right: ", ";\n  "], ["\n    position: absolute;\n    border-radius: ", ";\n    background: ", ";\n    z-index: 1;\n    right: ", ";\n  "])), theme.UNIT(2), theme.COLOR('canvas'), theme.UNIT(2))
});
var DialogStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'ConversationsPreviewAttachments',
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Image: styled(EntityImage)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  RemoveAttachmentButton: styled(IconButton)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), RemoveAttachmentButtonStyles),
  Dialog: styled(EntityDeleteDialog)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), DialogStyles)
};
export var ConversationsPreviewAttachments = function (props) {
  var _a = useComponentProps(My.NAME, props, ConversationsPreviewAttachmentsDefaultProps),
    className = _a.className,
    children = _a.children,
    entity = _a.entity,
    onDeleted = _a.onDeleted;
  var dialogs = useDialogs();
  var t = useLang();
  var onDeleteClick = function (entity) {
    dialogs.push(React.createElement(My.Dialog, {
      entity: entity,
      onDeleted: onDeleted
    }));
  };
  var onEntityDeleteAttachmentClick = function (event, entity) {
    event.stopPropagation();
    event.preventDefault();
    onDeleteClick(entity);
  };
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.RemoveAttachmentButton, {
    iconColor: 'mid',
    iconSize: 20,
    onClick: function (e) {
      return onEntityDeleteAttachmentClick(e, entity);
    },
    icon: React.createElement(CrossRoundedIconGlyph, {
      colors: {
        background: 'red'
      }
    })
  }), React.createElement(My.Image, {
    entity: entity
  }), children);
};
ConversationsPreviewAttachments.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;